import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';

import type { EditorView } from 'prosemirror-view';

import { I18nService } from '@core/i18n-legacy';
import type { EditorButton } from '@core/prosemirror-legacy';

@Pipe({
  name: 'rtEditorButtonLabel',
  pure: false,
  standalone: true,
})
export class EditorButtonLabelPipe implements PipeTransform {
  public i18n = inject(I18nService);

  public transform(button: EditorButton, editorView: EditorView): string {
    switch (typeof button.labelTranslationKey) {
      case 'string':
        return this.i18n.translate(button.labelTranslationKey);
      case 'function':
        return this.i18n.translate(button.labelTranslationKey(editorView.state));
      default:
        return '';
    }
  }
}
